import { render, staticRenderFns } from "./Ru.vue?vue&type=template&id=b6a02de8&scoped=true&"
import script from "./Ru.vue?vue&type=script&lang=js&"
export * from "./Ru.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a02de8",
  null
  
)

export default component.exports